import { Link } from 'react-router-dom'
import { Card } from '@/components/ui/Card'
import { Avatar } from '@/components/ui/Avatar'
import { Badge } from '@/components/ui/Badge'
import { Button } from '@/components/ui/Button'
import { TypeClientBadge } from './TypeClientBadge'
import { Eye, Mail, Phone, Building2, MoreHorizontal } from 'lucide-react'
import { formatDate } from '@/lib/utils'
import type { Client } from '@/types/client'

interface ClientCardProps {
  client: Client
}

export function ClientCard({ client }: ClientCardProps) {
  return (
    <Card className="hover:shadow-lg transition-shadow" padding="md">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <Avatar src={client.avatar_url} name={client.full_name} size="lg" />
          <div>
            <h3 className="font-semibold text-brown-900">{client.full_name}</h3>
            <TypeClientBadge type={client.type_client} size="sm" />
          </div>
        </div>
        <Button variant="ghost" size="sm">
          <MoreHorizontal className="w-4 h-4" />
        </Button>
      </div>

      <div className="space-y-2 mb-4">
        <div className="flex items-center text-sm text-brown-600">
          <Mail className="w-4 h-4 mr-2 text-brown-400" />
          {client.email}
        </div>
        {client.phone && (
          <div className="flex items-center text-sm text-brown-600">
            <Phone className="w-4 h-4 mr-2 text-brown-400" />
            {client.phone}
          </div>
        )}
        {client.company && (
          <div className="flex items-center text-sm text-brown-600">
            <Building2 className="w-4 h-4 mr-2 text-brown-400" />
            {client.company}
          </div>
        )}
      </div>

      <div className="flex items-center gap-2 mb-4">
        {client.projects_count !== undefined && client.projects_count > 0 && (
          <Badge variant="mint" size="sm">
            {client.projects_count} projet(s)
          </Badge>
        )}
        {client.factures_impayees !== undefined && client.factures_impayees > 0 && (
          <Badge variant="red" size="sm">
            {client.factures_impayees} impayee(s)
          </Badge>
        )}
      </div>

      <div className="flex items-center justify-between pt-4 border-t border-beige-200">
        <span className="text-xs text-brown-500">
          Client depuis {formatDate(client.created_at)}
        </span>
        <Link to={`/clients/${client.id}`}>
          <Button variant="outline" size="sm" leftIcon={<Eye className="w-4 h-4" />}>
            Voir
          </Button>
        </Link>
      </div>
    </Card>
  )
}
